import React from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';

const ImageModal = ({ images, currentIndex, onClose, onNext, onPrev }) => {
  if (!images || images.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[10000]">
      {/* زر الإغلاق */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-2xl text-white hover:text-gray-300"
      >
        <FaTimes />
      </button>

      {/* الصورة */}
      <div className="relative w-[90vw] h-[90vh] flex items-center justify-center">
        {/* زر التقلب إلى اليسار */}
        <button
  onClick={onPrev}
  className="absolute left-4 text-2xl text-white hover:text-gray-300 p-2 bg-black bg-opacity-50 rounded-full"
>
  <FaChevronLeft />
</button>

        {/* عرض الصورة */}
        <img
          src={images[currentIndex]}
          alt={`Gallery ${currentIndex}`}
          className="w-full h-full object-contain rounded-lg"
        />

        {/* زر التقلب إلى اليمين */}
        <button
  onClick={onNext}
  className="absolute right-4 text-2xl text-white hover:text-gray-300 p-2 bg-black bg-opacity-50 rounded-full"
>
  <FaChevronRight />
</button>
      </div>
    </div>
  );
};

export default ImageModal;